import React, { useState, useEffect } from "react";
import { toast } from "../../../../components/toastNotification";
import TextInput from "../../../../components/TextInput";
import { useRecoilState } from "recoil";
import ConfirmBoxModal from "../../../../components/ConfirmBoxModal";
import SalesTypeForm from "./SalesTypeForm";
import AddButton from "../../../../components/AddButton";
import ConfirmBoxDelete from "../../../../components/ConfirmBoxDelete";

import useSalesType from "./hooks/useSalesType";
import useDeleteSalesType from "./hooks/useDeleteSalesType";
import useUpdateSalesType from "./hooks/useUpdateSalesType";
import {
  addStateSalesType,
  selectedRowsStateSalesType,
  setFilterTextSalesType,
} from "./atoms/atoms";
import TableFilters from "../TableFilters";
import { PERMISSIONS } from "../../../PermissionsConstants";
import { useRecoilValue } from "recoil";
import { permissionsSelector } from "../../../Login/selectors/permissionSelector";
import { notificationFilterById } from "../../../../actions/Utilities/NotificationFilter";
import { useHistory, useLocation } from "react-router-dom";
import SaveButton from "../../../../components/SaveButton";
import CancelButton from "../../../../components/CancelButton";
import EditButton from "../../../../components/EditButton";
import { useQueryClient } from "react-query";
import MaterialOfficeConfigTable from "../../../../components/tables/MaterialOfficeConfigTable";

const SalesTypeTable = () => {
  //Hooks Call
  const { data, isFetching } = useSalesType();
  const { mutateAsync: UpdateSalesType } = useUpdateSalesType();
  const BulkDeleteSalesType = useDeleteSalesType();
  //Atoms Call
  const [actionAddState, setActionAddState] = useRecoilState(addStateSalesType);
  const [selectedRows, setSelectedRows] = useRecoilState(
    selectedRowsStateSalesType
  );
  const [filterText, setFilterText] = useRecoilState(setFilterTextSalesType);
  //Local States
  const [rowsCount, setRowsCount] = useState(0);
  const [editRowId, setEditRowId] = useState(null);
  const [actionEditState, setActionEditState] = useState(false);
  const [, setEmpTypeIsExistState] = useState(false);
  const [empTypeDataIsChange, setEmpTypeDataIsChange] = useState(false);
  const [checkStatus, setCheckStatus] = useState(false);
  const [openModalDelete, setOpenModalDelete] = useState(false);
  const [openModalEdit, setOpenModalEdit] = useState(false);
  const [hasSalesTypeType, setHasSalesTypeType] = useState(true);
  const [isBulkSelected, setIsBulkSelected] = useState(false);
  const [disabledButton, setDisabledButton] = useState(false);
  const [displayNote] = useState(false);
  const [edit, setEdit] = useState(false);
  const [hideColumn, sethideColumn] = useState(false);
  const [salesTypeFilteredData, setSalesTypeFilteredData] = useState([]);
  const queryClient = useQueryClient();
  const [editRowData, setEditRowData] = useState();

  const addPermission =
    PERMISSIONS.permission_utilities_officeconfiguration_salestype_add;
  const editPermission =
    PERMISSIONS.permission_utilities_officeconfiguration_salestype_edit;
  const deletePermission =
    PERMISSIONS.permission_utilities_officeconfiguration_salestype_delete;

  const userPermissions = useRecoilValue(permissionsSelector);

  const defaultValues = {
    salesTypeId: 0,
    salesTypeName: "",
  };
  const [empNewData, setNewData] = useState([defaultValues]);
  let location = useLocation();
  const history = useHistory();
  let recordIdFromRecent = "";
  if (location.state == null) {
    //Do nothing
  } else {
    recordIdFromRecent = location.state;
  }
  useEffect(() => {
    if (recordIdFromRecent) {
      try {
        notificationFilterById(
          recordIdFromRecent.recordId,
          recordIdFromRecent.moduleName,
          recordIdFromRecent.subModuleName
        ).then((result) => {
          setSalesTypeFilteredData(result);
          setSalesTypeId(recordIdFromRecent.recordId);
          history.replace();
        });
      } catch (error) {
        //console.log("error " + error);
      }
    } else {
      localStorage.removeItem("NotifFilter");
      localStorage.removeItem("ModuleFilter");
    }
  }, []);

  useEffect(() => {
    setEmpTypeIsExistState(false);
    setEmpTypeDataIsChange(false);
    setActionAddState(false);
    setActionEditState(false);
    setSelectedRows([]);
    setEditRowId([]);
  }, [setActionAddState, setSelectedRows]);

  const handleSelectedRowsChange = (rows) => {
    const forDelete = rows.filter((x) => x.isActive);
    setSelectedRows(forDelete);
    setRowsCount(forDelete.length);
    setIsBulkSelected((prev) => !prev);
  };

  const handleCheckBox = (checked) => {
    setEmpTypeDataIsChange(true);
    checked ? setCheckStatus(true) : setCheckStatus(false);
    checked
      ? empNewData.map((x) => (x.isActive = true))
      : empNewData.map((x) => (x.isActive = false));
  };

  const handleEditFieldsChange = (SourceType, fieldName, row, inputvalue) => {
    setEmpTypeIsExistState(false);
    setEmpTypeDataIsChange(false);
    inputvalue = inputvalue.trim();
    if (SourceType === "SalesTypeType") {
      if (fieldName === "salesTypeName") {
        setEmpTypeDataIsChange(true);
        empNewData.map((x) => (x.salesTypeName = inputvalue));
      }
      inputvalue === ""
        ? setHasSalesTypeType(false)
        : setHasSalesTypeType(true);
    }
  };

  const handleEditButton = (rowData) => {
    setEditRowId(rowData.salesTypeId);
    setEmpTypeDataIsChange(false);
    setEdit(true);
    setCheckStatus(rowData.isActive);
    setEditRowData({ ...rowData });
    empNewData.map((x) => (x.isActive = rowData.isActive));
    empNewData.map((x) => (x.salesTypeId = rowData.salesTypeId));
    empNewData.map((x) => (x.salesTypeName = rowData.salesTypeName));
    empNewData.map((x) => (x.createdOn = rowData.createdOn));
    empNewData.map((x) => (x.createdBy = rowData.createdBy));
  };

  //Save changes
  const handleSave = (empNewData) => {
    setOpenModalEdit(false);
    if (actionEditState) {
      UpdateSalesType(empNewData, {
        onSuccess: (res) => {
          if (res === "Duplicate") {
            toast.fire("Failed", "The data already exists!", "error");
            setOpenModalEdit(false);
          } else if (
            empNewData[0]?.salesTypeName === editRowData.salesTypeName &&
            empNewData[0]?.isActive === editRowData.isActive
          ) {
            toast.fire("Saving Failed", "No Changes have been made", "warning");
            setOpenModalEdit(false);
          } else {
            setNewData([defaultValues]);
            setEditRowId([]);
            setSelectedRows([]);
            setOpenModalEdit(false);
            setActionEditState(false);
            setDisabledButton(false);
            sethideColumn(false);
            setEdit(false);
            queryClient.invalidateQueries(["GetSalesType"]);
            toast.fire("Success", "Sales Type Updated Successfully", "success");
          }
        },
        onError: () => {
          toast.fire("Failed", "Failed to Update Sales Type", "error");
          queryClient.invalidateQueries(["GetSalesType"]);
          setOpenModalEdit(false);
        },
      });
    }
  };
  // end of saving changes

  const handleBulkDelete = () => {
    const ids = selectedRows.map((row) => row.salesTypeId);
    BulkDeleteSalesType(ids);
    setSelectedRows([]);
    setOpenModalDelete(false);
    setIsBulkSelected(false);
    setDisabledButton(false);
  };

  const deleteMessage = (
    <div className="text-gray-500 font-normal">{`Are you sure you want to deactivate ${rowsCount} ${
      rowsCount > 1 ? "Sales Types" : "Sales Type"
    }?`}</div>
  );

  const matColumns = [
    {
      title: "Sales Type Name",
      field: "salesTypeName",
      customSort: (a, b) =>
        a.salesTypeName && b.salesTypeName
          ? a.salesTypeName.trim().localeCompare(b.salesTypeName.trim())
          : a.salesTypeName
          ? 0
          : -1,
      render: (rowData) => {
        return rowData.salesTypeId === editRowId ? (
          <div className="flex items-center space-x-1 cursor-pointer">
            <TextInput
              placeholder="Sales Type"
              defaultValue={rowData.salesTypeName}
              onChange={(inputdata) => {
                handleEditFieldsChange(
                  "SalesTypeType",
                  "salesTypeName",
                  rowData,
                  inputdata.target.value
                );
              }}
            />
          </div>
        ) : (
          <>{rowData.salesTypeName}</>
        );
      },
    },
    {
      title: "Created By",
      field: "createdBy",
      hidden: hideColumn,
      render: (rowData) => {
        return rowData.officeTypeId === editRowId ? (
          <div className="flex items-center space-x-1 cursor-pointer"></div>
        ) : (
          <>{rowData.createdBy}</>
        );
      },
    },
    {
      title: "Created Date",
      field: "createdOn",
      hidden: hideColumn,
      render: (rowData) => {
        return rowData.officeTypeId === editRowId ? (
          <div className="flex items-center space-x-1 cursor-pointer"></div>
        ) : (
          <>
            {rowData.createdOn
              ? new Date(rowData.createdOn).toLocaleDateString()
              : ""}
          </>
        );
      },
    },
    {
      title: "Modified Date",
      field: "modifiedDate",
      hidden: hideColumn,
      render: (rowData) => {
        return rowData.officeTypeId === editRowId ? (
          <div className="flex items-center space-x-1 cursor-pointer"></div>
        ) : (
          <>
            {rowData.modifiedDate
              ? new Date(rowData.modifiedDate).toLocaleDateString()
              : ""}
          </>
        );
      },
    },
    {
      title: "Modified By",
      field: "modifiedBy",
      hidden: hideColumn,
      render: (rowData) => {
        return rowData.officeTypeId === editRowId ? (
          <div className="flex items-center space-x-1 cursor-pointer"></div>
        ) : (
          <>{rowData.modifiedBy}</>
        );
      },
    },

    {
      title: "Status",
      field: "isActive",
      align: "left",
      render: (rowData) => {
        return rowData.salesTypeId === editRowId ? (
          <div className="flex justify-start space-x-1 cursor-pointer">
            <input
              type="checkbox"
              className="flex items-center space-x-1 cursor-pointer"
              defaultChecked={rowData.isActive}
              onClick={(e) => {
                handleCheckBox(e.target.checked);
              }}
            />
            <label className="cursor-pointer text-green-600" name="Status">
              {checkStatus ? "Uncheck to Deactivate" : "Check to Activate"}
            </label>
          </div>
        ) : (
          <div>
            <div className="font-sans text-left mr-4 text-xs">
              {rowData.isActive ? "Active" : "Inactive"}
            </div>
          </div>
        );
      },
    },
    {
      title: "Action/s",
      align: "center",
      render: (rowData) => {
        return !userPermissions.includes(editPermission) ? (
          ""
        ) : rowData.salesTypeId === editRowId ? (
          <div className="flex place-content-center gap-2 ">
            <SaveButton
              className={`flex shadow-md text-xs font-semibold text-white  gap-x-1 rounded-full  bg-senary hover:bg-senary px-3 py-1 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-senary focus:ring-opacity-70
            ${
              !hasSalesTypeType || !empTypeDataIsChange
                ? "opacity-50"
                : "opactiy-100"
            }`}
              disabled={!hasSalesTypeType || !empTypeDataIsChange}
              onClick={() => {
                setOpenModalEdit(true);
              }}
            />
            <CancelButton
              className="flex text-xs shadow-md font-semibold text-white ml-1 gap-x-1 rounded-full bg-octonary hover:bg-octonary px-2 py-1 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-octonary focus:ring-opacity-70"
              onClick={() => {
                setActionEditState(false);
                setEditRowId([]);
                setEmpTypeDataIsChange(false);
                setEmpTypeIsExistState(false);
                setDisabledButton(false);
                setEdit(false);
                sethideColumn(false);
              }}
            />
          </div>
        ) : (
          <div className="flex items-center place-content-center mr-5">
            <EditButton
              disabled={disabledButton || selectedRows.length > 0}
              className={
                disabledButton || selectedRows.length > 0
                  ? "opacity-50 rounded-full items-center bg-quaternary text-white hover:bg-hquaternary"
                  : "opacity-100 rounded-full items-center bg-quaternary text-white hover:bg-hquaternary"
              }
              onClick={() => {
                setDisabledButton(true);
                setActionEditState(true);
                handleEditButton(rowData);
                sethideColumn(true);
              }}
            />
          </div>
        );
      },
    },
  ];

  //Filters
  const [salesTypeId, setSalesTypeId] = useState("");
  useEffect(() => {
    if (filterText) {
      setSalesTypeFilteredData(
        data?.filter((x) =>
          x.salesTypeName
            ?.toLowerCase()
            .includes(filterText.trim()?.toLowerCase())
        )
      );
    } else if (salesTypeId?.includes(".")) {
      let salesTypeIds = salesTypeId.split(".");
      const salesTypeIdsArr = salesTypeIds.map((id) => Number(id));
      const filteredData = data?.filter((x) =>
        salesTypeIdsArr.includes(x.salesTypeId)
      );

      setSalesTypeFilteredData(filteredData);
    } else {
      const filteredData = data?.filter(
        (x) => x.salesTypeId === Number(salesTypeId)
      );
      setSalesTypeFilteredData(filteredData);
    }
  }, [filterText, data]);

  return (
    <div className="animate-fade-in-down w-full">
      {actionAddState ? (
        ""
      ) : (
        <div className="font-bold text-primary text-xl uppercase ">
          {" "}
          {/* <h1> Sales Type</h1>{" "} */}
        </div>
      )}

      {!actionAddState && (
        <>
          <div className="bg-white p-4">
            <div className="flex flex-row justify-between items-center">
              <TableFilters
                filterText={setFilterText}
                moduleDetails="Sales Type Name"
                textInputName="salesTypeName"
                disabledButton={disabledButton || selectedRows.length > 0}
              ></TableFilters>

              <div>
                {userPermissions.includes(addPermission) ? (
                  <AddButton
                    buttonText="New Sales Type"
                    className={
                      selectedRows.length > 0 || actionEditState
                        ? "opacity-50"
                        : "opacity-100"
                    }
                    onClick={() => setActionAddState(!actionAddState)}
                    disabled={disabledButton || selectedRows.length > 0}
                  />
                ) : (
                  ""
                )}
              </div>
            </div>
            <div>
              {userPermissions.includes(deletePermission) ? (
                <div className="text-secondary italic text-xs3 my-2">
                  <p className="font-bold italic inline-block mr-1">Note:</p>
                  <span>Tick the box to deactivate some data.</span>
                </div>
              ) : (
                <div className="mb-4"></div>
              )}
            </div>

            <div className="">
              <MaterialOfficeConfigTable
                columns={matColumns}
                data={
                  salesTypeFilteredData?.length > 0
                    ? salesTypeFilteredData
                    : data
                    ? filterText === ""
                      ? data
                      : salesTypeFilteredData
                    : []
                }
                options={{
                  toolbar: false,
                  showTitle: false,
                }}
                selection={
                  !actionEditState && userPermissions.includes(deletePermission)
                }
                setOpenModal={setOpenModalDelete}
                onSelectionChange={handleSelectedRowsChange}
                selectedRows={selectedRows}
                isDeactivate={true}
                isLoading={isFetching}
              />
            </div>
          </div>
          <ConfirmBoxModal
            ModalTitle="Update Sales Type"
            qConfirmation=" Are you sure you want to update this?"
            isOpen={openModalEdit}
            onClose={() => {
              setOpenModalEdit(false);
              sethideColumn(true);
            }}
            onClickFunction={() => {
              handleSave(empNewData);
            }}
          />
          <ConfirmBoxDelete
            ModalTitle="Deactivate Sales Type"
            qConfirmation={deleteMessage}
            isOpen={openModalDelete}
            onClose={() => setOpenModalDelete(false)}
            onClickFunction={
              isBulkSelected ? handleBulkDelete : handleBulkDelete
            }
          />
        </>
      )}
      {actionAddState && (
        <div className="p-4">
          <SalesTypeForm />
        </div>
      )}
      {/* </div> */}
    </div>
  );
};

export default SalesTypeTable;
